import { useState } from "react";
import { Shield, CheckCircle2 } from "lucide-react";
import api from "../../services/api";

export default function LgpdConsentModal({ onAccepted }) {
  var checkedState = useState(false);
  var checked = checkedState[0];
  var setChecked = checkedState[1];
  var loadingState = useState(false);
  var loading = loadingState[0];
  var setLoading = loadingState[1];

  async function handleAccept() {
    if (!checked) return;
    setLoading(true);
    try {
      await api.post("/auth/accept-lgpd");
      onAccepted();
    } catch (err) {
      console.error("Erro ao aceitar LGPD:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" data-testid="lgpd-consent-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden">
        <div className="bg-[#0A2F3D] px-6 py-5 flex items-center gap-3">
          <div className="p-2.5 bg-white/10 rounded-xl">
            <Shield className="w-6 h-6 text-[#3B82F6]" />
          </div>
          <div>
            <h2 className="text-white font-bold text-lg">Protecao de Dados</h2>
            <p className="text-white/60 text-xs">Lei Geral de Protecao de Dados (LGPD)</p>
          </div>
        </div>

        <div className="p-6">
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 mb-5">
            <p className="text-sm text-gray-700 leading-relaxed">
              A <strong>Methos Corretora</strong> informa que os seus dados pessoais sao tratados com total sigilo e seguranca, em conformidade com a <strong>Lei Geral de Protecao de Dados (Lei n 13.709/2018 - LGPD)</strong>.
            </p>
          </div>

          <div className="space-y-3 mb-6">
            <div className="flex items-start gap-2.5">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-gray-600">Seus dados sao utilizados exclusivamente para a prestacao dos servicos contratados.</p>
            </div>
            <div className="flex items-start gap-2.5">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-gray-600">Nao compartilhamos suas informacoes com terceiros sem o seu consentimento.</p>
            </div>
            <div className="flex items-start gap-2.5">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-gray-600">Voce pode solicitar acesso, correcao ou exclusao dos seus dados a qualquer momento.</p>
            </div>
          </div>

          <label className="flex items-start gap-3 cursor-pointer group mb-5" data-testid="lgpd-checkbox-label">
            <input
              type="checkbox"
              checked={checked}
              onChange={function(e) { setChecked(e.target.checked); }}
              className="mt-0.5 w-5 h-5 rounded border-gray-300 text-[#3B82F6] focus:ring-[#3B82F6] cursor-pointer"
              data-testid="lgpd-checkbox"
            />
            <span className="text-sm text-gray-700 leading-relaxed">
              <strong>Estou ciente</strong> de que meus dados pessoais sao tratados de forma confidencial pela Methos Corretora, seguindo todas as normas da LGPD.
            </span>
          </label>

          <button
            onClick={handleAccept}
            disabled={!checked || loading}
            className={
              "w-full py-3 rounded-xl font-semibold text-sm transition-all " +
              (checked
                ? "bg-[#3B82F6] text-white hover:bg-[#2563EB] shadow-lg shadow-blue-500/20"
                : "bg-gray-100 text-gray-400 cursor-not-allowed")
            }
            data-testid="lgpd-accept-btn"
          >
            {loading ? "Processando..." : "Confirmar e Continuar"}
          </button>
        </div>
      </div>
    </div>
  );
}
